export default __webpack_public_path__ + "static/media/icon_category-garden-technology.93c4f99b.svg";